<mat-toolbar class="primary" *ngIf="loggedUser">
  <span class="adx-title">{{ appName }}</span>
  <span class="adx-toolbar-spacer"></span>
  <!-- Primary Menu Start-->
  <ng-template ngFor let-menu [ngForOf]="pluginInjectorService.getMenu().primary" let-index="index">
    <ng-template [ngIf]="hasMenuAccess(menu) && !isMobileView">
          <ng-template [ngIf]="menu.dropdown" [ngIfElse]="noDropdownPrimary">
            <span class="adx-badge-host">
              <button mat-icon-button class="adx-menu-icon adx-caret-icon-button"
                      [matMenuTriggerFor]="popup"
                      [matTooltip]="getMenuAriaLabel(menu)"
                      [attr.aria-label]="getMenuAriaLabel(menu)">
                <ng-container *ngIf="menu.iconLayers; else singleIconPrimaryDropdown">
                  <fa-layers>
                    <fa-icon *ngFor="let layer of menu.iconLayers"
                             [icon]="layer.icon"
                             [transform]="layer.transform ?? ''">
                    </fa-icon>
                  </fa-layers>
                </ng-container>
                <ng-template #singleIconPrimaryDropdown>
                  <fa-icon *ngIf="menu.icon" [icon]="menu.icon"></fa-icon>
                </ng-template>
                <fa-icon class="adx-caret-icon" *ngIf="menu.icon || menu.iconLayers" [icon]="'caret-down'" [size]="'xs'"></fa-icon>
              </button>
              <span class="adx-toolbar-badge" *ngIf="menu.badge$ | async as count">{{ count }}</span>
            </span>
            <!-- second level nested Menu-->
            <mat-menu #popup="matMenu">
              <ng-template ngFor let-item [ngForOf]="menu.dropdownItems">
                <ng-template [ngIf]="canAccessDropdownMenu(menu, item)">
                  <ng-template [ngIf]="item.class" [ngIfElse]="notClass">
                    <span>
                      <div>
                        <button mat-menu-item
                                [class]='(item.selected ? (item.selected() ? "selected" : "") : "") + " adx-theme-selector-option"'
                                (click)="triggerMenuCallback(item, index, menu);"
                        >
                        <span class="adx-tso-row">
                          <span>
                            <div class="adx-center adx-radio">
                              <div class="adx-dot">
                              </div>
                            </div>
                          </span>
                          <span *ngIf="item.pluginModule" class="adx-tso-row adx-spread">
                            <div class="adx-tso-row">
                              {{ item.pluginName + '.' + item.pluginModule + '.' + item.nameIdentifier | translate }}
                            </div>
                            <div class="adx-tso-row {{item.class}}">
                              <div class="adx-ex-primary">
                              </div>
                              <div class="adx-ex-secondary">
                              </div>
                              <div class="adx-ex-surface">
                              </div>
                            </div>
                          </span>
                          <span *ngIf="!item.pluginModule" class="adx-tso-row adx-spread">
                            <div class="adx-tso-row">
                              {{ item.pluginName + '.' + item.nameIdentifier | translate }}
                            </div>
                            <div class="adx-tso-row {{item.class}}">
                              <div class="adx-ex-primary">
                              </div>
                              <div class="adx-ex-secondary">
                              </div>
                              <div class="adx-ex-surface">
                              </div>
                            </div>
                          </span>
                        </span>
                        </button>
                      </div>
                    </span>
                  </ng-template>
                  <ng-template #notClass>
                    <span>
                      <button mat-menu-item
                              (click)="triggerMenuCallback(item, index, menu);"
                              [disabled]="item.disabled | async"
                      >
                        <span class="adx-dropdown-item-row">
                          <span>
                            <span *ngIf="item.label">{{ item.label }}</span>
                            <ng-container *ngIf="!item.label">
                              <span *ngIf="item.pluginModule">
                                {{ item.pluginName + '.' + item.pluginModule + '.' + item.nameIdentifier | translate }}
                              </span>
                              <span *ngIf="!item.pluginModule">
                                {{ item.pluginName + '.' + item.nameIdentifier | translate }}
                              </span>
                            </ng-container>
                          </span>
                          <span class="adx-item-badge" *ngIf="item.badge$ | async as count">{{ count }}</span>
                        </span>
                      </button>
                    </span>
                  </ng-template>
                </ng-template>
              </ng-template>
            </mat-menu>
          </ng-template>
          <ng-template #noDropdownPrimary>
            <button mat-icon-button
                    (click)="triggerMenuCallback(menu, index)"
                    [disabled]="menu.disabled | async"
                    [matTooltip]="getMenuAriaLabel(menu)"
                    [attr.aria-label]="getMenuAriaLabel(menu)"
            >
              <ng-template [ngIf]="getAltIcon(menu)" [ngIfElse]="normalIcon">
                <fa-icon class="adx-menu-icon" *ngIf="menu.altIcon" [icon]="menu.altIcon"></fa-icon>
              </ng-template>
              <ng-template #normalIcon>
                <ng-container *ngIf="menu.iconLayers; else singleIconPrimary">
                  <fa-layers class="adx-menu-icon">
                    <fa-icon *ngFor="let layer of menu.iconLayers"
                             [icon]="layer.icon"
                             [transform]="layer.transform ?? ''">
                    </fa-icon>
                  </fa-layers>
                </ng-container>
                <ng-template #singleIconPrimary>
                  <fa-icon class="adx-menu-icon" *ngIf="menu.icon" [icon]="menu.icon"></fa-icon>
                </ng-template>
              </ng-template>
            </button>
          </ng-template>
    </ng-template>
  </ng-template>
  <!-- Primary Menu Stop -->

  <span *ngIf="isMobileView; else isDesktopView" class="adx-badge-host adx-hamburger-host">
    <a class="bold"
       [matMenuTriggerFor]="secondaryMenu"
       (click)="toggleMenu()" aria-label="menu"
    >
      <fa-icon [icon]="'bars'"></fa-icon>
    </a>
    <span class="adx-toolbar-badge adx-hamburger-badge" *ngIf="hamburgerBadgeTotal as count">{{ count }}</span>
  </span>
  <mat-menu #secondaryMenu="matMenu" xPosition="before" class="app-navbar-dropdown">
    <!-- Primary items folded into hamburger on mobile -->
    <ng-template ngFor let-menu [ngForOf]="pluginInjectorService.getMenu().primary" let-index="index">
      <ng-template [ngIf]="hasMenuAccess(menu)">
        <ng-template [ngIf]="menu.dropdown" [ngIfElse]="noDropdownMobilePrimary">
          <button mat-menu-item [matMenuTriggerFor]="popupMobilePrimary">
            <span class="adx-dropdown-item-row">
              <span>
                <fa-icon class="adx-menu-icon" *ngIf="menu.icon" [icon]="menu.icon"></fa-icon>
                <span *ngIf="menu.pluginModule">
                  {{ menu.pluginName + '.' + menu.pluginModule + '.' + menu.nameIdentifier | translate }}
                </span>
                <span *ngIf="!menu.pluginModule">
                  {{ menu.pluginName + '.' + menu.nameIdentifier | translate }}
                </span>
              </span>
              <span class="adx-item-badge" *ngIf="menu.badge$ | async as count">{{ count }}</span>
            </span>
          </button>
          <mat-menu #popupMobilePrimary="matMenu">
            <ng-template ngFor let-item [ngForOf]="menu.dropdownItems">
              <ng-template [ngIf]="canAccessDropdownMenu(menu, item)">
                <button mat-menu-item
                        (click)="triggerMenuCallback(item, index, menu);"
                        [disabled]="item.disabled | async"
                >
                  <span class="adx-dropdown-item-row">
                    <span>
                      <span *ngIf="item.label">{{ item.label }}</span>
                      <ng-container *ngIf="!item.label">
                        <span *ngIf="item.pluginModule">
                          {{ item.pluginName + '.' + item.pluginModule + '.' + item.nameIdentifier | translate }}
                        </span>
                        <span *ngIf="!item.pluginModule">
                          {{ item.pluginName + '.' + item.nameIdentifier | translate }}
                        </span>
                      </ng-container>
                    </span>
                    <span class="adx-item-badge" *ngIf="item.badge$ | async as count">{{ count }}</span>
                  </span>
                </button>
              </ng-template>
            </ng-template>
          </mat-menu>
        </ng-template>
        <ng-template #noDropdownMobilePrimary>
          <button mat-menu-item
                  (click)="triggerMenuCallback(menu, index)"
                  [disabled]="menu.disabled | async"
          >
            <ng-container *ngIf="menu.iconLayers; else singleIconMobilePrimary">
              <fa-layers class="adx-menu-icon">
                <fa-icon *ngFor="let layer of menu.iconLayers"
                         [icon]="layer.icon"
                         [transform]="layer.transform ?? ''">
                </fa-icon>
              </fa-layers>
            </ng-container>
            <ng-template #singleIconMobilePrimary>
              <fa-icon class="adx-menu-icon" *ngIf="menu.icon" [icon]="menu.icon"></fa-icon>
            </ng-template>
            <span *ngIf="menu.pluginModule">
              {{ menu.pluginName + '.' + menu.pluginModule + '.' + menu.nameIdentifier | translate }}
            </span>
            <span *ngIf="!menu.pluginModule">
              {{ menu.pluginName + '.' + menu.nameIdentifier | translate }}
            </span>
          </button>
        </ng-template>
      </ng-template>
    </ng-template>
    <!-- Secondary items -->
    <ng-template ngFor let-menu [ngForOf]="pluginInjectorService.getMenu().secondary" let-index="index">
      <ng-template [ngIf]="hasMenuAccess(menu)">
        <ng-template [ngIf]="menu.dropdown" [ngIfElse]="noDropdownMobile">
          <button mat-menu-item [matMenuTriggerFor]="popup">
            <span class="adx-dropdown-item-row">
              <span>
                <fa-icon class="adx-menu-icon" *ngIf="menu.icon" [icon]="menu.icon"></fa-icon>
                <span *ngIf="menu.pluginModule">
                    {{ menu.pluginName + '.' + menu.pluginModule + '.' + menu.nameIdentifier | translate }}
                </span>
                <span *ngIf="!menu.pluginModule">
                    {{ menu.pluginName + '.' + menu.nameIdentifier | translate }}
                </span>
              </span>
              <span class="adx-item-badge" *ngIf="menu.badge$ | async as count">{{ count }}</span>
            </span>
          </button>
          <!-- second level nested Menu-->
          <mat-menu #popup="matMenu">
            <ng-template ngFor let-item [ngForOf]="menu.dropdownItems">
              <ng-template [ngIf]="canAccessDropdownMenu(menu, item)">
                <button mat-menu-item
                        (click)="triggerMenuCallback(item, index, menu);"
                        [disabled]="item.disabled | async"
                >
                  <span class="adx-dropdown-item-row">
                    <span>
                      <span *ngIf="item.label">{{ item.label }}</span>
                      <ng-container *ngIf="!item.label">
                        <span *ngIf="item.pluginModule">
                            {{ item.pluginName + '.' + item.pluginModule + '.' + item.nameIdentifier | translate }}
                        </span>
                        <span *ngIf="!item.pluginModule">
                            {{ item.pluginName + '.' + item.nameIdentifier | translate }}
                        </span>
                      </ng-container>
                    </span>
                    <span class="adx-item-badge" *ngIf="item.badge$ | async as count">{{ count }}</span>
                  </span>
                </button>
              </ng-template>
            </ng-template>
          </mat-menu>
        </ng-template>

        <ng-template #noDropdownMobile>
          <button mat-menu-item
                  (click)="triggerMenuCallback(menu, index)" [disabled]="menu.disabled | async"
          >
            <ng-template [ngIf]="getAltIcon(menu)" [ngIfElse]="normalIconMobile">
              <fa-icon class="adx-menu-icon" *ngIf="menu.altIcon" [icon]="menu.altIcon"></fa-icon>
              <span *ngIf="menu.altName; else normalNameMobile">
                  {{ menu.pluginName + '.' + menu.pluginModule + '.' + menu.altName | translate }}
              </span>
              <ng-template #normalNameMobile>
                <span *ngIf="menu.pluginModule">
                    {{ menu.pluginName + '.' + menu.pluginModule + '.' + menu.nameIdentifier | translate }}
                </span>
                <span *ngIf="!menu.pluginModule">
                    {{ menu.pluginName + '.' + menu.nameIdentifier | translate }}
                </span>
              </ng-template>
            </ng-template>
            <ng-template #normalIconMobile>
              <ng-container *ngIf="menu.iconLayers; else singleIconMobile">
                <fa-layers class="adx-menu-icon">
                  <fa-icon *ngFor="let layer of menu.iconLayers"
                           [icon]="layer.icon"
                           [transform]="layer.transform ?? ''">
                  </fa-icon>
                </fa-layers>
              </ng-container>
              <ng-template #singleIconMobile>
                <fa-icon class="adx-menu-icon" *ngIf="menu.icon" [icon]="menu.icon"></fa-icon>
              </ng-template>
              <span *ngIf="menu.pluginModule">
                  {{ menu.pluginName + '.' + menu.pluginModule + '.' + menu.nameIdentifier | translate }}
              </span>
              <span *ngIf="!menu.pluginModule">
                  {{ menu.pluginName + '.' + menu.nameIdentifier | translate }}
              </span>
            </ng-template>
          </button>
        </ng-template>
      </ng-template>
    </ng-template>
    <button mat-menu-item (click)="logout.callback()">
      <fa-icon class="adx-menu-icon" [icon]="logout.icon"></fa-icon>
      <span>{{ logout.name }}</span>
    </button>
  </mat-menu>

  <ng-template #isDesktopView>
    <!-- Secondary Menu Start -->
    <a class="adx-button bold" aria-label="username" [matMenuTriggerFor]="secondaryMenu" (click)="toggleMenu()">
      {{ loggedUser.full_name ?? loggedUser.login_name }}
      <fa-icon class="adx-menu-icon" [icon]="'caret-down'" [size]="'xs'"></fa-icon>
    </a>
   <core-plugin-lib-user-avatar
           [email]=loggedUser.email
           [name]="loggedUser.full_name ?? loggedUser.login_name"
           [size]="40">
   </core-plugin-lib-user-avatar>
   <mat-menu #secondaryMenu="matMenu" xPosition="before" class="app-navbar-dropdown">
      <ng-template ngFor let-menu [ngForOf]="pluginInjectorService.getMenu().secondary" let-index="index">
        <ng-template [ngIf]="hasMenuAccess(menu)">
          <ng-template [ngIf]="menu.dropdown" [ngIfElse]="noDropdownDesktop">
            <button mat-menu-item [matMenuTriggerFor]="popup">
              <span class="adx-dropdown-item-row">
                <span>
                  <fa-icon class="adx-menu-icon" *ngIf="menu.icon" [icon]="menu.icon"></fa-icon>
                  <span *ngIf="menu.pluginModule">
                      {{ menu.pluginName + '.' + menu.pluginModule + '.' + menu.nameIdentifier | translate }}
                  </span>
                  <span *ngIf="!menu.pluginModule">
                      {{ menu.pluginName + '.' + menu.nameIdentifier | translate }}
                  </span>
                </span>
                <span class="adx-item-badge" *ngIf="menu.badge$ | async as count">{{ count }}</span>
              </span>
            </button>
            <!-- second level nested Menu-->
            <mat-menu #popup="matMenu">
              <ng-template ngFor let-item [ngForOf]="menu.dropdownItems">
                <ng-template [ngIf]="canAccessDropdownMenu(menu, item)">
                  <button mat-menu-item
                          (click)="triggerMenuCallback(item, index, menu);"
                          [disabled]="item.disabled | async"
                  >
                    <span class="adx-dropdown-item-row">
                      <span>
                        <span *ngIf="item.label">{{ item.label }}</span>
                        <ng-container *ngIf="!item.label">
                          <span *ngIf="item.pluginModule">
                              {{ item.pluginName + '.' + item.pluginModule + '.' + item.nameIdentifier | translate }}
                          </span>
                          <span *ngIf="!item.pluginModule">
                              {{ item.pluginName + '.' + item.nameIdentifier | translate }}
                          </span>
                        </ng-container>
                      </span>
                      <span class="adx-item-badge" *ngIf="item.badge$ | async as count">{{ count }}</span>
                    </span>
                  </button>
                </ng-template>
              </ng-template>
            </mat-menu>
          </ng-template>

          <ng-template #noDropdownDesktop>
            <button mat-menu-item
                    (click)="triggerMenuCallback(menu, index)" [disabled]="menu.disabled | async"
            >
              <ng-template [ngIf]="getAltIcon(menu)" [ngIfElse]="normalIconDesktop">
                <fa-icon class="adx-menu-icon" *ngIf="menu.altIcon" [icon]="menu.altIcon"></fa-icon>
                <span *ngIf="menu.altName; else normalNameDesktop">
                    {{ menu.pluginName + '.' + menu.pluginModule + '.' + menu.altName | translate }}
                </span>
                <ng-template #normalNameDesktop>
                  <span *ngIf="menu.pluginModule">
                      {{ menu.pluginName + '.' + menu.pluginModule + '.' + menu.nameIdentifier | translate }}
                  </span>
                  <span *ngIf="!menu.pluginModule">
                      {{ menu.pluginName + '.' + menu.nameIdentifier | translate }}
                  </span>
                </ng-template>
              </ng-template>
              <ng-template #normalIconDesktop>
                <ng-container *ngIf="menu.iconLayers; else singleIconDesktop">
                  <fa-layers class="adx-menu-icon">
                    <fa-icon *ngFor="let layer of menu.iconLayers"
                             [icon]="layer.icon"
                             [transform]="layer.transform ?? ''">
                    </fa-icon>
                  </fa-layers>
                </ng-container>
                <ng-template #singleIconDesktop>
                  <fa-icon class="adx-menu-icon" *ngIf="menu.icon" [icon]="menu.icon"></fa-icon>
                </ng-template>
                <span *ngIf="menu.pluginModule">
                    {{ menu.pluginName + '.' + menu.pluginModule + '.' + menu.nameIdentifier | translate }}
                </span>
                <span *ngIf="!menu.pluginModule">
                    {{ menu.pluginName + '.' + menu.nameIdentifier | translate }}
                </span>
              </ng-template>
            </button>
          </ng-template>
        </ng-template>
      </ng-template>
      <button mat-menu-item (click)="logout.callback()">
        <fa-icon class="adx-menu-icon" [icon]="logout.icon"></fa-icon>
        <span>{{ logout.name }}</span>
      </button>
    </mat-menu>
    <!-- Secondary Menu Stop -->
  </ng-template>
</mat-toolbar>
